/* eslint-disable jira/filename-case */
import { autoBeforeEachTest } from '@jira/platform__utils-auto-before-each-test/src/auto-before-each-test.tsx';
import defaults from '../defaults.tsx';
import { batch, executeBatchedUpdate } from './batched-updates.tsx';
import supports from './supported-features.tsx';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SCHEDULE_QUEUE: any[] = [];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SYNC_QUEUE: any[] = SCHEDULE_QUEUE;

let scheduled: unknown;

let syncDepth = 0;
autoBeforeEachTest(() => {
	SCHEDULE_QUEUE.length = 0;
	syncDepth = 0;
});

/**
 * this function is an RSS version of React's flushSync
 * it will capture all updated called within it
 * and then notify all listeners without any extra delay
 */
export const scheduleSyncFlush = (cb: Function): void => {
	try {
		syncDepth++;
		cb();
	} finally {
		syncDepth--;
		if (syncDepth === 0) {
			executeBatchedUpdate(() => {
				let queueFn;
				// eslint-disable-next-line no-cond-assign
				while ((queueFn = SYNC_QUEUE.shift())) queueFn();
			});
		}
	}
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function schedule(fn: Function): any {
	// if we are in node/tests or feature disabled, make updates sync batched
	if (!defaults.batchUpdates || !supports.scheduling()) return executeBatchedUpdate(() => fn());

	if (syncDepth) {
		// we are in sync mode
		if (!SYNC_QUEUE.includes(fn)) SYNC_QUEUE.push(fn);
		return;
	}

	// Add to queue if not already there
	// so we avoid multiple notifications to same store listeners
	if (!SCHEDULE_QUEUE.includes(fn)) SCHEDULE_QUEUE.push(fn);

	// if something already started schedule, skip
	if (scheduled) return;

	scheduled = batch(() => {
		let queueFn;
		// eslint-disable-next-line no-cond-assign
		while ((queueFn = SCHEDULE_QUEUE.shift())) queueFn();
		scheduled = null;
	});
}
